/**
 * Email Flows Feature Constants
 */

// Re-export from other constant files
export * from './flowTriggers';
export * from './flowSteps';
export * from './audienceDefaults';
export * from './gridColumns';

// ============================================================================
// BUTTON NAMES (for analytics tracking)
// ============================================================================

export const BUTTON_NAMES = {
    // Onboarding
    ONBOARDING_UPGRADE: 'flows-onboarding-upgrade-creator-pro-button',
    ONBOARDING_GET_STARTED: 'flows-onboarding-get-started-button',
    ONBOARDING_CONTINUE: 'flows-onboarding-enter-address-continue-button',
    ONBOARDING_SUCCESS: 'flows-onboarding-success-button',

    // Empty States
    FLOW_EMPTY_STATE: 'flow-empty-state-button',
    BROADCAST_EMPTY_STATE: 'broadcast-empty-state-button',
    BROADCASTS_GO_TO_CUSTOMERS: 'broadcasts-go-to-customers-button',
} as const;

// ============================================================================
// BUTTON LABELS
// ============================================================================

export const BUTTON_LABELS = {
    UPGRADE_TO_PRO: 'Upgrade to Creator Pro',
    GET_STARTED: 'Get Started',
    CONTINUE: 'Continue',
    LETS_GO: "Let's Go",
    ADD_FLOW: 'Add Flow',
    SEND_EMAIL: 'Send Email',
    GO_TO_CUSTOMERS: 'Go to My Customers',
} as const;

// ============================================================================
// ONBOARDING STEPS
// ============================================================================

export const ONBOARDING_STEPS = {
    INTRODUCTION: 1,
    ENTER_ADDRESS: 2,
    SUCCESS: 3,
} as const;

// ============================================================================
// LOADING MESSAGES
// ============================================================================

export const LOADING_MESSAGES = {
    FLOWS: 'Loading flows...',
    BROADCASTS: 'Loading broadcasts...',
} as const;

// ============================================================================
// EMPTY STATE CONTENT
// ============================================================================

export const EMPTY_STATE_CONTENT = {
    FLOWS: {
        title: 'Create an Email Flow',
        description: 'Automatically send your customers drip emails after they purchase your products!',
        bulletPoints: ['Upsells', 'Thank You notes', 'Follow-up instructions'] as string[],
    },
    FLOWS_ONBOARDING: {
        title: 'What are Email Flows?',
        description: 'Automatically send your customers drip emails after a purchase!',
        bulletPointsHeading: 'You can use Email Flows for:',
        bulletPoints: ['Upsells', 'Thank You notes', 'Follow-up instructions', '... and much more!'] as string[],
    },
    BROADCASTS: {
        title: 'Broadcast a Message',
        description: 'Take your email marketing to the next level with Broadcasts!',
        bulletPoints: [
            'Send personalized messages',
            'Promote one-time offers',
            'Update customers on product news',
        ] as string[],
    },
    BROADCAST_BANNER: {
        title: 'Already have an Email List?',
        description: 'You can import your existing Email List through your Customers tab!',
    },
} as const;

// ============================================================================
// ONBOARDING CONTENT
// ============================================================================

export const ONBOARDING_CONTENT = {
    ADDRESS_STEP: {
        title: "What's Your Address?",
        subtitle:
            'We are legally required to show your business address (or your PO Box) in all your marketing emails.',
        learnMoreText: 'Learn more about',
        learnMoreLink: 'https://assets.stanwith.me/legal/CASL.pdf',
        learnMoreLinkText: 'Anti-Spam Compliance',
    },
    SUCCESS_STEP: {
        title: "You're All Set!",
        subtitle: "Let's get you started sending emails to your customers!",
    },
} as const;

// ============================================================================
// NOTIFICATION MESSAGES
// ============================================================================

export const NOTIFICATION_MESSAGES = {
    ONBOARDING: {
        SUCCESS: {
            title: 'Email flows onboarding completed successfully!',
            duration: 3000,
        },
        ERROR: {
            title: 'Onboarding failed',
            duration: 4000,
        },
        FINALIZE_ERROR: {
            title: 'Failed to finalize onboarding',
            duration: 4000,
        },
    },
} as const;

// ============================================================================
// ROUTES
// ============================================================================

export const ROUTES = {
    NEW_FLOW: '/flows/new',
    NEW_BROADCAST: '/flows/-1/broadcast/new',
} as const;
